<div class="flex vcenter">
  <h2>Cím</h2>
  @if (showToggle) {
    @if (form.enabled) {
      <button
        payee-icon-button
        color="white"
        (click)="form.disable()"
      >
        <payee-icon name="trash-red"></payee-icon>
      </button>
    }
    @if (form.disabled) {
      <button
        payee-button
        class="enable-address"
        (click)="form.enable()"
      >
        +
      </button>
    }
  }
</div>
@if (form.enabled || !showToggle) {
  <div class="flex">
    @let options = countryOptions();
    @if (options.length) {
      <payee-form-field
        width="short"
        [aiFilled]="isAiFilled(country_id)"
      >
        <payee-autocomplete
          [formControl]="country_id"
          [options]="options"
          [displayWith]="countryDisplayWith"
        ></payee-autocomplete>
        <span payee-label>Ország</span>
      </payee-form-field>
    }
    <payee-form-field
      width="short"
      [aiFilled]="isAiFilled(postcode)"
    >
      <input
        payee-input
        [formControl]="postcode"
      />
      <span payee-label>Irányítószám</span>
    </payee-form-field>
  </div>
  <payee-form-field
    width="wide"
    [aiFilled]="isAiFilled(settlement)"
  >
    <input
      payee-input
      [formControl]="settlement"
    />
    <span payee-label>Település</span>
  </payee-form-field>
  <payee-form-field
    width="wide"
    [aiFilled]="isAiFilled(street)"
  >
    <input
      payee-input
      [formControl]="street"
    />
    <span payee-label>Utca</span>
    <ng-container payee-error>
      @if (street.hasError("required")) {
        <mat-error>Mező kitöltése kötelező</mat-error>
      }
      @if (isStreetLong()) {
        <mat-error>A cím hosszabb mint 40 karakter</mat-error>
      }
    </ng-container>
  </payee-form-field>
}
